
// AUTOGENERATED FILE, TO UPDATE call npm run generate        
export enum ConfigSubObjectKeys{
    
/**
 * Conversation Options options that control the Patient1st chat conversation
 */
 conversation = "conversation",


/**
 * summaryOptions undefined conversation.summaryOptions
 */
 conversation_summaryOptions = "conversation.summaryOptions",


/**
 * nextStepDD options that control the DD used to generate suggestions conversation.nextStepDD
 */
 conversation_nextStepDD = "conversation.nextStepDD",


/**
 * LLM Configuration Configuration options for the LLM (when use-llm enabled) * Deprecated - use root.llmOptions * conversation.nextStepDD.llmOptions
 */
 conversation_nextStepDD_llmOptions = "conversation.nextStepDD.llmOptions",


/**
 * resultsDD options that control the DD used to generate final results conversation.resultsDD
 */
 conversation_resultsDD = "conversation.resultsDD",


/**
 * LLM Configuration Configuration options for the LLM (when use-llm enabled) * Deprecated - use root.llmOptions * conversation.resultsDD.llmOptions
 */
 conversation_resultsDD_llmOptions = "conversation.resultsDD.llmOptions",


/**
 * LLM Options Configuration options for the LLM (when use-llm enabled) llmOptions
 */
 llmOptions = "llmOptions",


/**
 * Paths Options (preloader) options that control the paths constructed in preloader pathsOptions
 */
 pathsOptions = "pathsOptions",


/**
 * Client Feature Flags options that control the front end fe
 */
 fe = "fe",


/**
 * Theme options that control the chat theming theme
 */
 theme = "theme",


/**
 * colors undefined theme.colors
 */
 theme_colors = "theme.colors",


/**
 * Backoffice options that are sensitive and should be used only within the server backoffice
 */
 backoffice = "backoffice",


/**
 * Webhook Configuration undefined backoffice.webhook
 */
 backoffice_webhook = "backoffice.webhook",


/**
 * Email Configuration currently we only support email.js as email provider backoffice.email
 */
 backoffice_email = "backoffice.email",


/**
 * Whatsapp Configuration authentication, keys, message templates, and touch-points backoffice.whatsapp
 */
 backoffice_whatsapp = "backoffice.whatsapp",


/**
 * SMS Configuration from number, message templates, and touch-points backoffice.sms
 */
 backoffice_sms = "backoffice.sms",


/**
 * Subscription Options official organization name, point of contact and plan and billing information backoffice.subscriptionOptions
 */
 backoffice_subscriptionOptions = "backoffice.subscriptionOptions",


/**
 * Clinic general options for clinic configuration clinic
 */
 clinic = "clinic",


/**
 * Kahun Dialogue configuration Enable Kahun Dialogue and set the App ID clinic.dialogue
 */
 clinic_dialogue = "clinic.dialogue",


/**
 * Standalone configuration Configure standalone (clinic manage) options clinic.standalone
 */
 clinic_standalone = "clinic.standalone",


/**
 * Conversion Tracking Google Analytics, Facebook Pixel, etc. clinic.conversionTracking
 */
 clinic_conversionTracking = "clinic.conversionTracking",


/**
 * Agent Diagnosis options that control the diagnosis run by the agent agentDD
 */
 agentDD = "agentDD",


/**
 * LLM Configuration Configuration options for the LLM (when use-llm enabled) * Deprecated - use root.llmOptions * agentDD.llmOptions
 */
 agentDD_llmOptions = "agentDD.llmOptions",

}
